import {
  dashboardIcon,
  listIcon,
  partnershipIcon,
  people,
  stairs,
  view
} from "../assets";

export const resourcesPrimaryModule = [
  {
    href: "/neighborhoods/",
    image: stairs,
    title: "NYC neighborhood guides",
    description:
      "Like it busy? Quiet? Close to the park? Find the right corner of NYC for you."
  },
  {
    href: "/blog/nyc-housing-market-data/ ",
    image: people,
    title: "Housing market data",
    description:
      "Read the latest market trends, or dive into prices and data across the five boroughs."
  },
  {
    href: "/blog/",
    image: view,
    title: "Hand-curated listings",
    description:
      "See editors’ picks for the top rentals and sales available now — and more."
  }
];

export const resourcesSecondaryModule = [
  {
    href: "/blog/series/renting-in-nyc/",
    icon: listIcon,
    text: "Renting in NYC: The Ultimate Guide"
  },
  {
    href: "/blog/series/first-time-home-buyer-nyc/",
    icon: partnershipIcon,
    text: "How to Buy a Home in NYC"
  },
  {
    href: "/guides/sellers-guide/",
    icon: dashboardIcon,
    text: "The NYC Home Sellers’ Guide"
  }
];

export const searchPriceType = {
  MIN: "min",
  MAX: "max"
};

export const updateSearchRequestParams = {
  refined_search: true,
  utf8: "✓",
  amenities: [],
  opt_amenities: [],
  area: [],
  available_date: "",
  available_range: "on_before",
  baths: "",
  beds: null,
  boundary: null,
  by_owner: null,
  description: "",
  has_3d_tour: null,
  has_videos: null,
  income_restricted: "",
  maintenance: "",
  new_developments: "",
  no_fee: null,
  open_house: "",
  ppsf_from: "",
  ppsf_to: "",
  ppsf_unknown: null,
  pre_war: "",
  price_from: "",
  price_to: "",
  sale_type: [],
  search_by_address: "",
  sqft: "",
  status: "",
  taxes: "",
  transit_lines: [],
  type: "",
  year_built_from: "",
  year_built_to: "",
  zip: ""
};
